import React from 'react';
import { Award, Shield, CheckCircle, Lightbulb, Heart, Link } from 'lucide-react';
import { aboutData } from '../data/mock';

const iconMap = {
  Award: Award,
  Shield: Shield,
  CheckCircle: CheckCircle,
  Lightbulb: Lightbulb,
  Heart: Heart,
  Link: Link,
};

const AboutSection = () => {
  return (
    <section id="about" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-orange-100 rounded-full mb-6">
              <span className="text-sm font-medium text-orange-700">À Propos</span>
            </div>
            
            <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-6">
              {aboutData.title}
            </h2>
            
            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              {aboutData.intro}
            </p>

            {/* Vision Box */}
            <div className="bg-white rounded-2xl p-6 border border-orange-100 shadow-sm">
              <h3 className="text-lg font-bold text-slate-900 mb-3 flex items-center gap-2">
                <span className="w-8 h-8 bg-orange-100 rounded-lg flex items-center justify-center">
                  <Lightbulb className="w-4 h-4 text-orange-500" />
                </span>
                {aboutData.vision.title}
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {aboutData.vision.text}
              </p>
            </div>
          </div>

          {/* Right - Values Grid */}
          <div className="grid grid-cols-2 gap-4">
            {aboutData.values.map((value, index) => {
              const IconComponent = iconMap[value.icon];
              return (
                <div
                  key={index}
                  className="group bg-white rounded-2xl p-6 hover:shadow-xl hover:shadow-slate-200/50 transition-all duration-300 border border-slate-100 hover:border-orange-200"
                >
                  <div className="w-12 h-12 bg-orange-50 group-hover:bg-orange-100 rounded-xl flex items-center justify-center mb-4 transition-colors">
                    <IconComponent className="w-6 h-6 text-orange-500" />
                  </div>
                  <h4 className="font-semibold text-slate-900 mb-1">
                    {value.title}
                  </h4>
                  <p className="text-sm text-slate-500">
                    {value.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
